var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 200,
    viewBox: "0 0 192 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18234_94782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.8224 193.985C40.0856 190.591 31.2743 185.335 31.2743 179.441C31.2743 173.546 39.6425 168.562 52.7657 165.16",
    stroke: "#FECC53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.557 165.202C141.578 168.604 149.869 173.716 149.869 179.432C149.869 189.664 123.324 197.966 90.5759 197.966C83.1281 197.966 75.9955 197.532 69.4253 196.749",
    stroke: "#FECC53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9107 103.571L17.4181 121.926C14.3077 126.493 15.8245 132.745 20.6818 135.39L83.6819 169.625C93.9334 175.196 106.741 172.1 113.294 162.463L128.548 140.068",
    stroke: "#69B0E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.567 98.9182L188.353 52.2395C191.463 47.672 189.946 41.4204 185.089 38.7752L122.08 4.53168C111.829 -1.03948 99.0209 2.05656 92.4678 11.6934L35.4669 95.4139",
    stroke: "#69B0E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.498 136.828C137.774 136.828 131.514 130.578 131.514 122.87C131.514 115.161 137.774 108.912 145.498 108.912C153.221 108.912 159.482 115.161 159.482 122.87C159.482 130.578 153.221 136.828 145.498 136.828Z",
    stroke: "#ECEBE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.083 147.196V163.433",
    stroke: "#ECEBE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.945 155.31H172.213",
    stroke: "#ECEBE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.322 55.9819L128.642 61.5871C132.357 63.6115 137.002 62.5312 139.456 59.0865L147.654 47.5444C150.551 43.4702 149.23 37.7885 144.833 35.3984L134.513 29.7932C130.798 27.7689 126.154 28.8491 123.699 32.2939L115.502 43.836C112.604 47.9101 113.925 53.5919 118.322 55.9819Z",
    stroke: "#FECC53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0782 96.1963L69.647 93.8743C68.3347 93.1853 66.7155 93.6021 65.8975 94.8269L59.0632 104.983C58.1002 106.412 58.5945 108.359 60.1284 109.159L69.255 113.93C70.7889 114.738 71.2831 116.703 70.3031 118.132L65.2328 125.515C64.2613 126.927 64.73 128.875 66.2383 129.691L77.0608 135.569C78.3646 136.275 80.0007 135.883 80.8358 134.659L83.1537 131.273",
    stroke: "#FECC53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2496 123.874L100.947 130.516C102.259 131.205 103.878 130.789 104.696 129.564L111.531 119.4C112.493 117.971 111.999 116.023 110.465 115.223L101.364 110.46C99.8304 109.652 99.3362 107.696 100.316 106.267L104.27 100.5C105.242 99.0882 104.773 97.149 103.265 96.3239L92.4422 90.4466C91.1384 89.7406 89.5023 90.1319 88.6671 91.3567L82.3697 100.534",
    stroke: "#FECC53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.374 38.5795L127.134 51.0912",
    stroke: "#FECC53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.186 48.9393L131.122 45.0437",
    stroke: "#FECC53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.638 107.764L178.084 83.1743",
    stroke: "#ECEBE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8989 63.8581L106.077 20.25",
    stroke: "#ECEBE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.126 46.9915L115.715 25.1832",
    stroke: "#ECEBE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.343 155.31L136.78 147.196",
    stroke: "#ECEBE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18234_94782"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 191.25,
    height: 198.75,
    fill: "white",
    transform: "matrix(-1 0 0 1 191.25 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.4411a3a2358cb7ce4b191cffd1b5e49b.svg";
export { ForwardRef as ReactComponent };